var map = {
	"./1.svg": 3873,
	"./10.svg": 87600,
	"./11.svg": 12318,
	"./12.svg": 57753,
	"./13.svg": 48428,
	"./14.svg": 51319,
	"./15.svg": 38457,
	"./16.svg": 46560,
	"./17.svg": 98430,
	"./18.svg": 57769,
	"./19.svg": 75508,
	"./2.svg": 2089,
	"./20.svg": 89041,
	"./21.svg": 24848,
	"./22.svg": 59755,
	"./23.svg": 58461,
	"./24.svg": 48680,
	"./25.svg": 66475,
	"./26.svg": 84448,
	"./27.svg": 61580,
	"./28.svg": 50633,
	"./29.svg": 53284,
	"./3.svg": 49545,
	"./4.svg": 55082,
	"./43.svg": 83370,
	"./5.svg": 83869,
	"./6.svg": 7649,
	"./7.svg": 49802,
	"./8.svg": 70129,
	"./9.svg": 30914
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23297;